module.exports = __webpack_public_path__ + "static/media/icon-lojas.ef06ccc0.svg";